import React, { FC } from 'react';
import ProjectAdmin from '../components/project_admin';

const ProjectUsers: FC = () => {
    return <ProjectAdmin />;
};

export default ProjectUsers;
